import { useState } from 'react';
import { getClient } from '@sentry/react';
import FeedbackForm from './FeedbackForm';

const FeedbackButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const client = getClient();

  if (!client) {
    return null;
  }

  return (
    <>
      <button type="button" className="btn btn-xs btn-accent" onClick={() => setIsFormOpen(true)}>
        Report Bug
      </button>
      {isFormOpen && <FeedbackForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />}
    </>
  );
};

export default FeedbackButton;
